import TagManager from 'react-gtm-module';

const DEFAULT_CONVERSION = {
  send_to: 'AW-803342317/BAjYCIy80_AbEO2PiP8C',
  value: 1.0,
  currency: 'EUR',
};

/**
 * Track custom events in Google Tag Manager
 * @param {string} event - The event name
 * @param {Object} dataLayer - Additional data to send with the event
 */
export function trackEvent(event, dataLayer = {}) {
  TagManager.dataLayer({
    dataLayer: {
      event,
      ...dataLayer,
    },
  });
}

/**
 * Track page views in Google Tag Manager
 * @param {string} pageName - The page name or path
 * @param {Object} additionalData - Additional data to send with the page view
 */
export function trackPageView(pageName, additionalData = {}) {
  TagManager.dataLayer({
    dataLayer: {
      event: 'page_view',
      page_name: pageName,
      ...additionalData,
    },
  });
}

/**
 * Track movie/TV show interactions
 * @param {string} action - The action performed (view, favorite, add_to_watchlist, etc.)
 * @param {string} contentType - 'movie' or 'tv'
 * @param {Object} contentInfo - Information about the content
 */
export function trackContentInteraction(action, contentType, contentInfo = {}) {
  trackEvent('content_interaction', {
    action,
    content_type: contentType,
    content_id: contentInfo.id,
    content_title: contentInfo.title,
    content_genre: contentInfo.genre,
    content_rating: contentInfo.rating,
  });
}

/**
 * Track search events
 * @param {string} searchTerm - The search term used
 * @param {number} resultsCount - Number of results returned
 */
export function trackSearch(searchTerm, resultsCount = 0) {
  trackEvent('search', {
    search_term: searchTerm,
    results_count: resultsCount,
  });
}

/**
 * Track user authentication events
 * @param {string} action - 'login', 'register', 'logout'
 * @param {string} method - 'email', 'google', etc.
 */
export function trackAuth(action, method = 'email') {
  trackEvent('auth', {
    action,
    method,
  });
}

/**
 * Track Google login events for provider-specific reporting
 */
export function trackGoogleLogin() {
  trackEvent('google_login', {
    method: 'google',
  });
}

/**
 * Track Google Ads conversion events
 * @param {Object} conversionData - Conversion data including send_to, value, currency
 */
export function trackConversion(conversionData = {}) {
  // Use gtag if available, otherwise fall back to dataLayer
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      ...DEFAULT_CONVERSION,
      ...conversionData,
    });
  } else {
    // Fallback to GTM dataLayer
    TagManager.dataLayer({
      dataLayer: {
        event: 'conversion',
        ...DEFAULT_CONVERSION,
        ...conversionData,
      },
    });
  }
} 